module.exports = __webpack_public_path__ + "img/BA_Generic.15813b3f.png";